module.exports = __webpack_public_path__ + "media/images/profile/3-1fd48d399c0c8e0101c53007c2f5b970.jpg";